var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sk-spinner sk-spinner-double-bounce" }, [
      _c("div", { staticClass: "sk-double-bounce1" }),
      _c("div", { staticClass: "sk-double-bounce2" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }